import React from "react";
import Contact from "./components/Contact";
import DownloadSection from "./components/DownloadSection";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ScreenshotGallery from "./components/ScreenshotGallery";
import "./styles/global.css";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Features />
        <ScreenshotGallery />
        <DownloadSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
